import { AnalyticsStore, updateSearch } from 'bernie-core';

import { History, Location } from 'history';

export const handleMapTrigger = (history: History, location: Location, analytics: AnalyticsStore) => () => {
  updateSearch({ history, location, newParams: { pwaOverlay: 'map' } });
  if (analytics && typeof analytics.trackEvent === 'function') {
    analytics.trackEvent('Module.MapOpen.Link', 'Launch dynamic map', null);
  }
};
